<template>
  <teleport to="body">
  <div id="outer-area"
    class="d-flex align-items-center justify-content-center"
    @click.self="clickedOuterArea()">
    <div class="editor-area">

      <div class="mb row">
        <label class="col-sm-2 col-form-label">No.{{record.index}}</label>
        <div class="col-sm-10">
        </div>
      </div>

      <div class="mb-2 row">
        <label class="col-sm-2 col-form-label">注文番号</label>
        <div class="col-sm-10">
          <input type="text" readonly class="form-control-plaintext" :value="record.orderId">
        </div>
      </div>

      <div class="mb-2 row">
        <label class="col-sm-2 col-form-label">商品</label>
        <div class="col-sm-10">
          <input type="text" readonly class="form-control-plaintext" :value="productName">
        </div>
      </div>

      <div class="mb-2 row">
        <label class="col-sm-2 col-form-label">名前</label>
        <div class="col-sm-10">
          <input type="text" class="form-control" v-model="record.recipientName">
        </div>
      </div>

      <div class="mb-2 row">
        <label class="col-sm-2 col-form-label">郵便番号</label>
        <div class="col-sm-4">
          <input type="text" class="form-control" v-model="record.shipPostalCode">
        </div>
        <label class="col-sm-2 col-form-label">都道府県</label>
        <div class="col-sm-4">
          <input type="text" class="form-control" v-model="record.shipState">
        </div>
      </div>

      <div class="mb-2 row">
        <label class="col-sm-2 col-form-label">市町村</label>
        <div class="col-sm-10">
          <input type="text" class="form-control" v-model="record.shipCity">
        </div>
      </div>

      <div class="mb-2 row">
        <label class="col-sm-2 col-form-label">住所1</label>
        <div class="col-sm-10">
          <input type="text" class="form-control" v-model="record.shipAddress1">
        </div>
      </div>

      <div class="mb-2 row">
        <label class="col-sm-2 col-form-label">住所2</label>
        <div class="col-sm-10">
          <input type="text" class="form-control" v-model="record.shipAddress2">
        </div>
      </div>

      <div class="mb-2 row">
        <label class="col-sm-2 col-form-label">住所3</label>
        <div class="col-sm-10">
          <input type="text" class="form-control" v-model="record.shipAddress3">
        </div>
      </div>

      <div class="mb-2 row">
        <label class="col-sm-2 col-form-label">配送方法</label>
        <div class="col-sm-2">
          <select class="form-select form-select-sm" v-model.number="record.shipMethod">
            <option v-for="n in ShipMethod" :key="n.Index" v-bind:value="n.Index">{{ n.Label }}</option>
          </select>
        </div>
      </div>

      <div class="mb-2 row">
        <label class="col-sm-2 col-form-label">メモ(選択)</label>
        <div class="col-sm-9">
          <select class="form-select form-select-sm" v-model.number="record.manualSelectMemo">
            <option v-for="n in ManualSelectMemo" :key="n.Index" v-bind:value="n.Index">{{ n.Label }}</option>
          </select>
        </div>
      </div>

      <div class="mb-2 row">
        <label class="col-sm-2 col-form-label">メモ(手入力)</label>
        <div class="col-sm-10">
          <input type="text" class="form-control" v-model="record.memo">
        </div>
      </div>

      <div class="mb-2 row">
        <label class="col-sm-8 col-form-label"></label>
        <div class="col-sm-2">
          <button type="button" class="btn btn-primary" @click="onClickEdit()">編集</button>
        </div>
        <div class="col-sm-2">
          <button type="button" class="btn btn-secondary" @click="onClickCancel()">キャンセル</button>
        </div>
      </div>

    </div>
  </div>
  </teleport>
</template>

<script>
import { ref, defineComponent, toRef } from 'vue'
import { ManualSelectMemo, ShipMethod } from '@/const/const'
import createStore from '@/store/index.js'

export default defineComponent({
  props: {
    row: {
      required: true
    }
  },
  emits: ['closeEditor'],
  setup (props, context) {
    const store = createStore
    const tmp = toRef(props, 'row')
    const record = ref(JSON.parse(JSON.stringify(tmp.value)))
    console.log(record.value)
    const productName = ref(record.value.items[0].productName)
    /*
    const orderId = ref(record.value.orderId)
    const index = ref(record.value.index)
    const recipientName = ref(record.value.recipientName)
    const shipPostalCode = ref(record.value.shipPostalCode)
    const shipState = ref(record.value.shipState)
    const shipCity = ref(record.value.shipCity)
    const shipAddress1 = ref(record.value.shipAddress1)
    const shipAddress2 = ref(record.value.shipAddress2)
    const shipAddress3 = ref(record.value.shipAddress3)
    const shipMethod = ref(record.value.shipMethod)
    const memo = ref(record.value.memo)
    const manualSelectMemo = ref(record.value.manualSelectMemo)
    */
    const clickedOuterArea = () => {
      context.emit('closeEditor')
    }

    const onClickEdit = () => {
      /*
      record.value.recipientName = recipientName.value
      record.value.shipPostalCode = shipPostalCode.value
      record.value.shipState = shipState.value
      record.value.shipCity = shipCity.value
      record.value.shipAddress1 const shipAddress1 = ref()
      const shipAddress2 = ref(record.value.shipAddress2)
      const shipAddress3 = ref(record.value.shipAddress3)
      const shipMethod = ref(record.value.shipMethod)
      const memo = ref(record.value.memo)
      const manualSelectMemo = ref(record.value.manualSelectMemo)
      */
      store.commit('updateEditorShippingRecord', { targetRecord: tmp.value, record: record.value })
      context.emit('closeEditor')
    }

    const onClickCancel = () => {
      context.emit('closeEditor')
    }

    return {
      record,
      productName,
      /*
      orderId,
      index,
      productName,
      recipientName,
      shipPostalCode,
      shipState,
      shipCity,
      shipAddress1,
      shipAddress2,
      shipAddress3,
      shipMethod,
      memo,
      manualSelectMemo,
      */
      ManualSelectMemo,
      ShipMethod,
      onClickEdit,
      onClickCancel,
      clickedOuterArea
    }
  }
})
</script>

<style lang="scss" scoped>
#outer-area {
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0px;
  left: 0px;
  background-color: rgba(0, 0, 0, 0.5);
  .editor-area {
    align-items: center;
    background-color: #f5f5f5;
    width: 50%;
    border-radius: 6px;
    font-size: 15px;
    padding: 20px 24px 20px 24px;
    margin: 0 auto;
    vertical-align: middle;
    z-index: 2;
  }
}
</style>
